<template>
<div>
    <v-card>
        <v-card-title>
            Search user
            <v-spacer></v-spacer>            
            <v-btn color="primary" to="/AdminDevices">Search device</v-btn>
            <div class="ma-2"></div>
            <v-btn to="/deviceList">back to devices page</v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="4" md="4">
                    <v-text-field col="md-4"
                        v-model="username"
                        prepend-icon="mdi-magnify"
                        label="Username"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-col>

                <v-col cols="12" sm="2" md="2">
                    <v-btn 
                    color="primary"
                    @click="searchUser"
                    :disabled="!username"
                    >Search</v-btn>                        
                </v-col>
            </v-row> 
            <v-row>
                <v-col cols="12" sm="4" md="4">
                <v-card v-if="user_detail.username">
                    <v-card-title>
                        {{user_detail.username}}
                        <v-spacer></v-spacer>
                        <v-btn text color="blue" @click="getUserLogs">view logs</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <div class="text-body-2">
                            <span class="text-body-1">faculty :</span> {{user_detail.faculty}}<br>
                            <span class="text-body-1">registered devices :</span> {{user_detail.device_count}}<br>

                            <span class="text-body-1">quota :</span> <v-text-field type="number"
                            v-model="user_detail.quota"></v-text-field><br>

                            <span class="text-body-1">type:</span> <v-select 
                            v-model="user_detail.type"
                            :items="user_schema.properties.type.enum.map(e => { return {type:e}})"
                            item-text="type"
                            item-value="type"
                            ></v-select>
                        </div>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                        text
                        color="blue"
                        :disabled="!user_detail.quota || !user_detail.type"
                        @click="updateUser"
                        >update</v-btn>

                    </v-card-actions>
                </v-card>
                </v-col>
                <v-col cols="12" sm="8" md="8">
                    <v-card v-if="logs.length>0">
                        <v-card-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search logs"
                            single-line
                            hide-details
                        ></v-text-field>
                        
                        </v-card-title>
                        <v-data-table
                        :headers="headers"
                        :items="logs"
                        :search="search"
                        :sort-by="['time']"
                        :sort-desc="['ture']"
                        :loading="!this.logs.length"
                        loading-text="Loading... Please wait"
                        item-key="id"
                        ></v-data-table>
                    </v-card>
                </v-col>
            </v-row>           
        </v-card-text>
    </v-card>
    <v-col cols="12" sm="6" md="6">
      <v-alert outlined :type="errorMsg.type" v-if="errorMsg.show">
        {{errorMsg.text.statusText}}<br>        
        {{errorMsg.text}}        
      </v-alert>
    </v-col>
</div>
</template>

<script>
import Vue from 'vue';
import axios from "axios";

export default Vue.extend({
    name: "AdminUsers",
    data: () => ({
        username: null,
        access_token: sessionStorage.getItem('access_token'),
        user_info: JSON.parse(sessionStorage.getItem('user_info')),
        user_detail: {},
        errorMsg: {show:false, text:null, type:"error"},
        user_schema: {},
        logs: [],
        search: '',
        headers: [
            {text: 'id', value: 'id', filterable: false},
            {text: 'time', value: 'time'},
            {text: 'message', value: 'str_message'}
        ]
    }),
    mounted () {
        axios
        .get(
            this.$store.state.api_url+`/users/`+this.user_info.cmuitaccount_name,
            {headers: { Authorization: `Bearer ${this.access_token}`}}
        )
        .then((response)=>{
            if (response.data.type!=='admin') {
                this.$router.push(`/Error`)
            }
        })
        .catch((error)=>{
            if (error.response) {        
                //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
                const errTxt = {
                    status: error.response.status,
                    statusText: error.response.statusText,
                    detail: error.response.data
                }
                Object.assign(this.errorMsg,{show:true, text: errTxt, type:"error"}) 
            } else if (error.request) {            
                this.$router.push(`/Error`)
            } else {            
                this.$router.push(`/Error`)
            }            
        })

        axios
        .get(
            this.$store.state.api_url+`/schema/user`
        )
        .then((response)=>{
            this.user_schema = response.data
        })
        .catch((error)=>{
            if (error.response) {        
                //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
                const errTxt = {
                    status: error.response.status,
                    statusText: error.response.statusText,
                    detail: error.response.data
                }
                Object.assign(this.errorMsg,{show:true, text: errTxt, type:"error"}) 
            } else if (error.request) {            
                this.$router.push(`/Error`)
            } else {            
                this.$router.push(`/Error`)
            }
        }) 

    },

    methods: {
        searchUser () {
            this.errorMsg.show=false
            this.user_detail={}
            this.logs=[]
            axios
            .get(
                this.$store.state.api_url+`/users/`+this.username,
                {headers: { Authorization: `Bearer ${this.access_token}`}}
            )
            .then((response)=>{
                this.user_detail = response.data
            })
            .catch((error)=>{
                if (error.response) {        
                    //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
                    const errTxt = {
                        status: error.response.status,
                        statusText: error.response.statusText,
                        detail: error.response.data
                    }
                    Object.assign(this.errorMsg,{show:true, text: errTxt, type:"error"}) 
                } else if (error.request) {            
                    this.$router.push(`/Error`)
                } else {            
                    this.$router.push(`/Error`)
                }    
            })
        },

        updateUser () {
            this.errorMsg.show=false
            Object.assign(this.user_detail,{quota: parseInt(this.user_detail.quota)})
            axios
            .put(
                this.$store.state.api_url+`/users`,
                this.user_detail,
                {headers: { Authorization: `Bearer ${this.access_token}`}}
            )
            .then((response)=>{
                Object.assign(this.errorMsg,{show:true, text: response.data, type:"success"})
            })
            .catch((error)=>{
                if (error.response) {        
                    //this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)
                    const errTxt = {
                        status: error.response.status,
                        statusText: error.response.statusText,
                        detail: error.response.data
                    }
                    Object.assign(this.errorMsg,{show:true, text: errTxt, type:"error"}) 
                } else if (error.request) {            
                    this.$router.push(`/Error`)
                } else {            
                    this.$router.push(`/Error`)
                }    
            })
        },

        getUserLogs () {
            this.errorMsg.show=false
            axios.get(
                this.$store.state.api_url+`/logs/`+this.username,
                {headers: { Authorization: `Bearer ${this.access_token}`}}
            )
            .then((response)=>{        
                this.logs = response.data.map((e)=>{
                    e.str_message = JSON.stringify(e.message)
                    delete e.message
                    return e
                })
            })
            .catch((error)=>{
                if (error.response) {        
                    this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}`)            
                } else if (error.request) {            
                    this.$router.push(`/Error`)
                } else {            
                    this.$router.push(`/Error`)
                } 
            })
        }
    }    
});
</script>